import React from "react";

// components
import BaseApi from "../../utils/BaseApi";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import {CircularProgress} from "@mui/joy";


class WebinarAttendeeTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            attendees: null,
        };
    }

    async componentDidMount() {
        await this.retrieveAttendees();
    }

    async retrieveAttendees() {
        await this.setState(
            {
                attendees: null
            }
        );
        const url = `webinar/${this.props.webinar.id}`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        await this.setState(
            {
                attendees: response.data.attendees,
            }
        );
    }

    render() {
        if (!this.state.attendees) {
            return (<CircularProgress/>)
        }
        return (
            <CommonPaginatedTable
                data={this.state.attendees}
                fields={[
                    {
                        title: 'Фамилия',
                        name: 'last_name',
                        visible: true,
                        linkPattern: '/hub/marketing_user/detail/:linkParam',
                        linkParam: 'id',
                    },
                    {
                        title: 'Имя',
                        name: 'first_name',
                        visible: true,
                    },
                    {
                        title: 'Отчество',
                        name: 'patronymic',
                        visible: true,
                    },
                    {
                        title: 'Компания',
                        name: 'account_title',
                        visible: true,
                    },
                    {
                        title: 'Должность',
                        name: 'role',
                        visible: true,
                    },
                    {
                        title: 'Эл. почта',
                        name: 'email',
                        visible: true,
                    },
                    {
                        title: 'Телефон',
                        name: 'phone',
                        visible: true,
                    },

                ]
                }
            />
        )
    }
}

export default WebinarAttendeeTab